import {Component} from 'react';
import {ListeningRoomService} from '../../services/websocketService';

class MentorListeningRoomInitializer extends Component {
  state = {}; // solves bug described in CFW-916
  constructor(props) {
    super(props);
  }
  componentDidMount = () => {
    this.deleteConnectToPeerListeningRoom = ListeningRoomService.connectToPeerListeningRoom(
      // in order to publish to peer's listening room even while not online
      this.props.peerUserId,
      this.props.currentUser.userId,
    );
    // console.debug(this.deleteConnectToPeerListeningRoom);
  };
  componentWillUnmount = () => {
    // console.debug('removing peer listening room listener in call');
    this.deleteConnectToPeerListeningRoom &&
      this.deleteConnectToPeerListeningRoom();
  };
  render() {
    return null;
  }
}

export default MentorListeningRoomInitializer;
